import React, { useState } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';


const SaleReportFilter = (props) => {

    const [errorMessage, setErrorMessage] = useState("")


    const handleFilterDate = () => {

        if (!props.allDateSelected && (!props.startDate || !props.endDate)) {
            setErrorMessage("Please select both From Date and Upto Date.");
            return;
        }

        if (!props.allDateSelected && (new Date(props.startDate) > new Date(props.endDate))) {
            setErrorMessage("From Date cannot be greater than Upto Date.");
            return;
        }


        props.getChallanData()
        props.setShowDateModel(false);
    }

    const handleAllDateSeleceted = () => {
        if (props.allDateSelected) {
            const today = new Date().toISOString().split("T")[0];
            props.setStartDate(today);
            props.setEndDate(today);
        } else {
            props.setStartDate("");
            props.setEndDate("");
        }


        props.setAllDateSelected(!props.allDateSelected)
    }

    const handleCloseModel = () => {
        props.setShowDateModel(false);
        props.setAllDateSelected(true);
        props.setStartDate("");
        props.setEndDate("");
    }

    const handleCusotmerName = (event, value) => {

        console.log(value, "value data ")

        if (value) {
            props?.setPartyId(value.id);
        } else {
            props?.setPartyId(null);
        }
    };

    const handleVoucherName = (event, value) => {
        console.log(value, "value data ")

        if (value) {
            props?.setVoucherTypeName(value.vou_type_name);
        } else {
            props?.setVoucherTypeName(null);
        }
    }



    // select the  item name
    const handleSingleItem = (event, value) => {
        if (value === null || value === undefined) {
            props?.setItemId(null);
            return;
        } else {
            props?.setItemId(value.id);
        }
    }

    const selectBookingTypeFilter = (e) => {
        props.setBookTypeFilter(e.target.value);
    };


    const selectStatusFilter = (e) => {
        props.setStatusId(e.target.value);
    };

    return (
        <>
            <Form>

                {errorMessage && (
                    <div style={{ color: 'red', marginBottom: '10px' }}>{errorMessage}</div>
                )}
                <Card
                    style={{
                        backgroundColor: '#ffffcc',
                        padding: '15px',
                        border: '1px solid #999',
                    }}
                >

                    <Row >
                        {/* Left Side - Checkbox */}
                        {<Col xl={12} style={{ marginLeft: 20 }}>


                            {/* <FormGroup check> */}
                            <Label check>
                                <Input
                                    type="checkbox"
                                    checked={props.allDateSelected}
                                    onChange={() => handleAllDateSeleceted()}
                                />{' '}
                                All Date Select
                            </Label>
                            {/* </FormGroup> */}

                        </Col>}

                        {/* Right Side - Date Inputs */}
                        {!props.allDateSelected &&
                            <Col xl={12}>

                                <FormGroup row>
                                    <Label for="props.startDate" sm={3} style={{ fontWeight: 'bold' }}>
                                        From
                                    </Label>
                                    <Col sm={9}>
                                        <Input
                                            type="date"
                                            id="props.startDate"
                                            value={props.startDate}
                                            disabled={props.allDateSelected}
                                            onChange={(e) => props.setStartDate(e.target.value)}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="props.endDate" sm={3} style={{ fontWeight: 'bold' }}>
                                        Upto
                                    </Label>
                                    <Col sm={9}>
                                        <Input
                                            type="date"
                                            id="props.endDate"
                                            value={props.endDate}
                                            disabled={props.allDateSelected}
                                            onChange={(e) => props.setEndDate(e.target.value)}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>}
                    </Row>

                    {props.itemOption && <Row style={{ marginTop: 10, alignItems: "center" }}>
                        <Col sm="auto">
                            <Label for="itemSelect" style={{ marginBottom: 0, marginRight: 6, fontWeight: 'bold' }}>Item Name</Label>
                        </Col>
                        <Col>
                            <FormGroup style={{}} > {/* Adjust width as needed */}
                                {/* <Autocomplete 
                                    id="item_name"
                                    name="item_name"
                                    options={props.itemTable.map((option) => ({ id: option.id, label: option.item_name }))}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                    value={props.itemId || ''}
                                    onChange={handleSingleItem}
                                /> */}


                                <Autocomplete
                                    size="small"
                                    autoHighlight
                                    id="item_name"
                                    name="item_name"
                                    options={props.itemTable || []}
                                    getOptionLabel={(option) => `${option.item_name}`}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Party Code" style={{ backgroundColor: "white" }} />
                                    )}
                                    renderOption={(props, option, { index }) => (
                                        <li {...props} key={option.id || index}>
                                            {`${option.item_name}`}
                                        </li>
                                    )}
                                    value={props.itemTable.find(option => option.id == props.itemId) || null}
                                    onChange={(event, value) => {
                                        handleSingleItem(event, value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>}

                    {props.partyOption && <Row style={{ marginTop: 10, alignItems: "center" }}>
                        <Col sm="auto">
                            <Label for="itemSelect" style={{ fontWeight: 'bold' }}>Party Name</Label>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Autocomplete
                                    size="small"
                                    autoHighlight
                                    id="pcode"
                                    name="pcode"
                                    options={props.partyTable || []} // Ensure options are never undefined
                                    getOptionLabel={(option) => `${option.name} - ${option.party_agr_code}-${option.party_company_name} - ${option.mobile_number}`} // Correct concatenation
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Party Code" style={{ backgroundColor: "white" }} />
                                    )}
                                    renderOption={(props, option, { index }) => (
                                        <li {...props} key={option.id || index}>
                                            {`${option.name} - ${option.party_agr_code}- ${option.party_company_name} -  ${option.mobile_number}`} {/* Correct concatenation */}
                                        </li>
                                    )}
                                    value={props.partyTable.find(option => option.id == props.partyId) || null}
                                    // 🔥 THIS is where debounce should be triggered
                                    onInputChange={(event, value, reason) => {
                                        if (reason === "input") {
                                            props.debouncedGetPartyData(value);
                                        }
                                    }}
                                    onFocus={() => {
                                        if (props.partyTable.length == 0) {
                                            props.debouncedGetPartyData();
                                        }
                                    }}
                                    onChange={(event, value) => {
                                        handleCusotmerName(event, value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>}



                    {props.voucherTypeOption && <Row style={{ marginTop: 10, alignItems: "center" }}>
                        <Col sm="auto">
                            <Label for="itemSelect" style={{ marginBottom: 0, marginRight: 10 }}>Voucher Type</Label>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Autocomplete
                                    size="small"
                                    autoHighlight
                                    id="vou_type_name"
                                    name="vou_type_name"
                                    options={props.voucherTypeList || []}
                                    getOptionLabel={(option) => `${option.vou_type_name}`}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Voucher Type" />
                                    )}
                                    renderOption={(props, option, { index }) => (
                                        <li {...props} key={option.id || index}>
                                            {`${option.vou_type_name}`}
                                        </li>
                                    )}
                                    value={props.voucherTypeList.find(option => option.vou_type_name == props.voucherTypeName) || null}
                                    onChange={(event, value) => {
                                        handleVoucherName(event, value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>}


                    {props.bookingTypeOption && <Row style={{ marginTop: 10, alignItems: "center" }}>
                        <Col sm="auto">
                            <Label for="itemSelect" style={{ marginBottom: 0, marginRight: 10 }}>Booking Type</Label>
                        </Col>
                        <Col>
                            <FormGroup>

                                <Input

                                    type="select" className="custom-select"
                                    name="bookTypeFilter"
                                    value={props.bookTypeFilter}
                                    onChange={(e) => selectBookingTypeFilter(e)}
                                >
                                    {props.bookingTypeList.map((item, index) => (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>}



                    {props.statusOption && <Row style={{ marginTop: 10, alignItems: "center" }}>
                        <Col sm="auto">
                            <Label for="itemSelect" style={{ marginBottom: 0, marginRight: 40, fontWeight: "bold" }}>Status</Label>
                        </Col>
                        <Col>
                            <FormGroup>

                                <Input

                                    type="select" className="custom-select"
                                    name="statusId"
                                    value={props.statusId}
                                    onChange={(e) => selectStatusFilter(e)}
                                >
                                    <option value="">Select Status</option>
                                    {props.statusTable.map((item, index) => (
                                        <option key={index} value={item.field_name}>
                                            {item.field_data}
                                        </option>
                                    ))}
                                </Input>


                                {/* <Autocomplete
                                    size="small"
                                    autoHighlight
                                    id="vou_type_name"
                                    name="vou_type_name"
                                    options={props.voucherTypeList || []}
                                    getOptionLabel={(option) => `${option.vou_type_name}`}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Select Voucher Type" />
                                    )}
                                    renderOption={(props, option, { index }) => (
                                        <li {...props} key={option.id || index}>
                                            {`${option.vou_type_name}`}
                                        </li>
                                    )}
                                    value={props.voucherTypeList.find(option => option.vou_type_name == props.voucherTypeName) || null}
                                    onChange={(event, value) => {
                                        handleVoucherName(event, value);
                                    }}
                                /> */}
                            </FormGroup>
                        </Col>
                    </Row>}
                </Card>

                {/* <ModalFooter> */}
                <Col style={{ display: "flex", alignSelf: "flex-end", justifyContent: "flex-end", gap: 5, marginTop: 10 }}>
                    <Button color="danger" type='button' onClick={handleCloseModel}>
                        Cancel
                    </Button>
                    <Button color="primary ml-3" type='button' onClick={handleFilterDate}>
                        Apply
                    </Button>
                </Col>
                {/* </ModalFooter> */}


            </Form >
        </>
    )
}

export default SaleReportFilter